// @ts-nocheck
import { useRef, useState } from 'react';
import { FileText, UploadCloud, X, AlertCircle } from 'lucide-react';
import { DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { KNOWLEDGE_BASE_ACCEPT, KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES } from '@/utilities/constant';
import '../builder-v2/ui/studio.css';
import '../kbcreate.css';


export function KbDialogContent({ className = '', children, ...props }: any) {
  return (
    <DialogContent className={`ags ags-kbdlg ${className}`} overlayClassName="ags-kbdlg-ov" {...props}>
      {children}
    </DialogContent>
  );
}

export function KbDialogHead({ icon: Icon, title, sub, danger }: any) {
  return (
    <div className="ags-sh" style={{ marginBottom: 18, paddingRight: 40 }}>
      <div className="ags-ico" style={danger ? { background: 'var(--red-t)', color: 'var(--red)', boxShadow: 'none' } : undefined}>
        <Icon className="ags-i" />
      </div>
      <div className="ags-grow">
        <DialogTitle>{title}</DialogTitle>
        {sub ? <DialogDescription>{sub}</DialogDescription> : null}
      </div>
    </div>
  );
}

const MAX_LABEL = `${(KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES / 1024 / 1024).toFixed(0)} MB`;
const EXT = String(KNOWLEDGE_BASE_ACCEPT || '')
  .split(',')
  .map((t) => t.trim().toLowerCase())
  .filter((t) => t.startsWith('.'));
const fmt = (n: number) => (n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(1)} KB` : `${(n / 1048576).toFixed(1)} MB`);


export function KbFileDrop({ file = [], onChange, onError, invalid }: any) {
  const ref = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);

  const pick = (list: FileList | null) => {
    if (!list || list.length === 0) return;
    const f = list[0];
    if (EXT.length && !EXT.some((e) => f.name.toLowerCase().endsWith(e))) {
      onError?.(`${f.name} is not allowed. Only ${EXT.map((e) => e.slice(1).toUpperCase()).join(', ')} files are accepted.`);
      return;
    }
    if (f.size > KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES) {
      onError?.(`${f.name} exceeds ${MAX_LABEL} limit`);
      return;
    }
    onChange?.([f]);
  };

  return (
    <>
      <button
        type="button"
        className={`ags-kbdrop${over ? ' ags-over' : ''}${invalid ? ' ags-invalid' : ''}`}
        onClick={() => ref.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          pick(e.dataTransfer.files);
        }}
      >
        <UploadCloud className="ags-i" style={{ width: 26, height: 26, color: 'var(--muted)' }} />
        <b>Drop a file here, or click to browse</b>
        <span className="ags-hint">{`PDF, DOC, DOCX or TXT, up to ${MAX_LABEL}`}</span>
      </button>
      <input
        ref={ref}
        type="file"
        className="hidden"
        accept={KNOWLEDGE_BASE_ACCEPT}
        onChange={(e) => {
          pick(e.target.files);
          e.target.value = '';
        }}
      />
      {file.length > 0 && (
        <div className="ags-kbfile">
          <FileText className="ags-i" />
          <div className="ags-nm">
            <b>{file[0].name}</b>
            <small>{fmt(file[0].size)}</small>
          </div>
          <button type="button" className="ags-x" aria-label={`Remove ${file[0].name}`} onClick={() => onChange?.([])}>
            <X className="ags-i" />
          </button>
        </div>
      )}
    </>
  );
}

export const ErrMsg = ({ children }: any) =>
  children ? (
    <div className="ags-msg ags-err ags-show">
      <AlertCircle className="ags-i" />
      <span>{children}</span>
    </div>
  ) : null;